import { render, staticRenderFns } from "./addReferralOrder.vue?vue&type=template&id=6a01f428&scoped=true&"
import script from "./addReferralOrder.vue?vue&type=script&lang=js&"
export * from "./addReferralOrder.vue?vue&type=script&lang=js&"
import style0 from "./addReferralOrder.vue?vue&type=style&index=0&id=6a01f428&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a01f428",
  null
  
)

export default component.exports